var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.obj.user_name)+": список избранного")]),_vm._v(" "),(_vm.obj.favs)?_c('videoComponent',{attrs:{"videos":_vm.obj.favs}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }